import { Select, MenuItem, FormControl, useTheme, Box, Typography } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useLanguage } from "../../contexts/LanguageContext";

interface LanguageSelectorProps {
  size?: 'small' | 'medium';
  sx?: any;
  isMobile?: boolean;
}

function LanguageSelector({ size = 'small', sx = {}, isMobile = false }: LanguageSelectorProps) {
  const { language, updateLanguage, getSupportedLanguages } = useLanguage();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  if (isMobile) {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center', ...sx }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            height: '36px',
            px: 1,
            borderRadius: '10px',
            backgroundColor: isDark ? '#252836' : '#F0F0F2',
            border: isDark ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.08)',
            cursor: 'pointer',
            pointerEvents: 'none',
          }}
        >
          <LanguageIcon sx={{ fontSize: '20px', color: isDark ? '#8A8FA8' : '#666' }} />
          <Typography sx={{ fontSize: '12px', fontWeight: 600, color: isDark ? '#FFFFFF' : '#1A1A2E', textTransform: 'uppercase' }}>
            {language}
          </Typography>
        </Box>
        <Select
          value={language}
          onChange={(e) => updateLanguage(e.target.value as any)}
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            opacity: 0,
            '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
            '& .MuiSelect-icon': { display: 'none' },
          }}
        >
          {getSupportedLanguages().map((lang) => (
            <MenuItem key={lang.code} value={lang.code}>
              {lang.nativeName}
            </MenuItem>
          ))}
        </Select>
      </Box>
    );
  }

  return (
    <FormControl size={size} sx={{ minWidth: 120, ...sx }}>
      <Select
        value={language}
        onChange={(e) => updateLanguage(e.target.value as any)}
        sx={{
          height: '40px',
          backgroundColor: isDark ? '#252836' : '#F0F0F2',
          border: isDark ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.08)',
          borderRadius: '10px',
          color: isDark ? '#FFFFFF' : '#1A1A2E',
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '& .MuiSelect-icon': {
            color: isDark ? '#8A8FA8' : '#666',
          },
        }}
      >
        {getSupportedLanguages().map((lang) => (
          <MenuItem key={lang.code} value={lang.code}>
            {lang.nativeName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default LanguageSelector;
